interface ActivityTrendGraphProps {
  /** Scores 0–100 for each data point across the day */
  scores: number[];
}

const WIDTH = 280;
const HEIGHT = 40;

export function ActivityTrendGraph({ scores }: ActivityTrendGraphProps) {
  if (scores.length < 2) return null;

  const points = scores
    .map((score, i) => {
      const x = (i / (scores.length - 1)) * WIDTH;
      const y = HEIGHT - (score / 100) * (HEIGHT - 4) - 2;
      return `${x.toFixed(1)},${y.toFixed(1)}`;
    })
    .join(' ');

  return (
    <div className="flex flex-col gap-1" data-testid="activity-trend-graph">
      <p
        className="field-label"
        style={{ fontSize: '10px', letterSpacing: '0.08em' }}
      >
        ACTIVITY TREND
      </p>
      <div className="relative">
        <svg
          width="100%"
          height={HEIGHT}
          viewBox={`0 0 ${WIDTH} ${HEIGHT}`}
          preserveAspectRatio="none"
          aria-hidden="true"
        >
          <polyline
            points={points}
            stroke="#c8651a"
            strokeWidth="1"
            strokeLinejoin="round"
            strokeLinecap="round"
            data-testid="activity-polyline"
          />
        </svg>
        {/* X-axis labels */}
        <div className="flex justify-between mt-0.5 px-0">
          {(['DAWN', 'MID', 'DUSK'] as const).map((label) => (
            <span
              key={label}
              className="text-[var(--color-text-placeholder)]"
              style={{ fontSize: '10px', textTransform: 'uppercase', letterSpacing: '0.08em' }}
            >
              {label}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
